import { useCallback, useState } from "react";
import { useRequestManager } from "../common/RequestManager";
import { Modal } from "../common/Modal";
import { EditNote_SupplierProduct_EditSupplierProductNoteMutation, EditNote_SupplierProduct_EditSupplierProductNoteMutationVariables, EditNote_SupplierProductFragment } from "../../../codegen/graphql";
import { gql, useMutation, useSuspenseFragment } from "@apollo/client";

const EDIT_NOTE_SUPPLIER_PRODUCT_FRAGMENT = gql`
  fragment EditNote_SupplierProduct on SupplierProduct {
    id
    note
  }
`;

// Edit Supplier Product Note
export const EDIT_SUPPLIER_PRODUCT_NOTE = gql`
  mutation EditNote_SupplierProduct_EditSupplierProductNote($id: String!, $note: String) {
    editSupplierProductNote(id: $id, note: $note) {
      id
      note
    }
  }
`;
export const mutation_editSupplierProductNote = () => useMutation<
  EditNote_SupplierProduct_EditSupplierProductNoteMutation,
  EditNote_SupplierProduct_EditSupplierProductNoteMutationVariables
>(EDIT_SUPPLIER_PRODUCT_NOTE);

export function EditNote_SupplierProduct_Modal({
  onClose,
  supplierProduct,
}: {
  onClose: () => void;
  supplierProduct: EditNote_SupplierProductFragment;
}) {
  const { data: fragmentData } = useSuspenseFragment<EditNote_SupplierProductFragment>({
    fragment: EDIT_NOTE_SUPPLIER_PRODUCT_FRAGMENT,
    fragmentName: 'EditNote_SupplierProduct',
    from: supplierProduct,
  });
  const { trackRequest } = useRequestManager();
  const [editSupplierProductNote] = mutation_editSupplierProductNote()

  const [noteText, setNoteText] = useState(fragmentData.note || '');
  
  const handleSaveNote = useCallback(async () => {
    trackRequest(
      editSupplierProductNote({
        variables: {
          id: fragmentData.id,
          note: noteText || null,
        },
      }), {
        title: 'Sauvegarde de la note',
        isBlocking: false,
      }
    );
  }, [editSupplierProductNote, fragmentData.id, noteText]);

  return (
    <Modal
      onClose={onClose}
      title="Éditer la note"
      width="medium"
      actions={[
        {
          label: 'Annuler',
          onClick: onClose,
          preset: 'white',
        },
        {
          label: 'Sauvegarder',
          onClick: () => {
            handleSaveNote();
            onClose();
          },
          preset: 'primary',
        },
      ]}
    >
      <textarea
        className="w-full h-32 p-2 border rounded-lg"
        value={noteText}
        onChange={(e) => setNoteText(e.target.value)}
        placeholder="Entrez votre note ici..."
      />
    </Modal>
  );
}